import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Shimmer = ({ width, height, classNames }) => (
    <div
        style={{ width: width, height: height }}
        className={`shimmer ${classNames}`}
    />
);

Shimmer.propTypes = {
    width: PropTypes.any.isRequired,
    height: PropTypes.number.isRequired,
    classNames: PropTypes.string
};

export default memo(Shimmer);
